import React, { useRef, useState } from 'react'
import { UploadEl } from '../Elements'
import VideoRecordStore from '../Stores/VideoRecordStore'
import Uppy from '@uppy/core'
import FileInput from '@uppy/file-input'
import { notify } from '../../../Helpers/Notifications'
import { Text } from '../../../Styles/typography'

function UploadVid() {
  const {
    recordingState,
    setRecordingState,
    submit,
  } = VideoRecordStore.useContainer()

  const input = useRef(null)
  const [progress, setProgress] = useState(0)

  new Uppy({
    debug: true,
    autoProceed: true,
    restrictions: {
      maxFileSize: 50 * 1024 * 1024,
      maxNumberOfFiles: 1,
      allowedFileTypes: ['video/*'],
    },
    onBeforeFileAdded: () => {
      setRecordingState('UPLOADING')
      setProgress(0)
      notify('success', 'Starting Upload...')
    },
  })
    .use(FileInput, {
      target: input.current,
      replaceTargetContent: true,
    })
    .on('file-added', async (file) => {
      notify('success', 'Successfully uploaded the file.')
      console.log(file)
      await submit.current(file.data)
    })
    .on('upload-error', (file, error) => {
      notify('error', error.message)
    })

  return (
    <UploadEl progress={progress}>
      {recordingState === 'NOT RECORDED' ? (
        <div className='upload-option'>
          <b>or</b>
          <div className='uploadBtn'>
            <div ref={input} className='input' />
            Upload Video
          </div>
        </div>
      ) : (
        recordingState === 'UPLOADING' && <Text>Uploading...</Text>
      )}
    </UploadEl>
  )
}

export default UploadVid
